import * as types from '../types.js'

const state = {
    contacts: []
}

const getters = {}
const actions = {
    [types.CONTACTS_REQUEST]: ({commit, dispatch}, requestParams) => {
        return axios.get('/api/contact', {
            withCredentials: true,
            params: requestParams
        })
            .then(resp => {
                commit(types.CONTACTS_SUCCESS, resp)
            })
            .catch(err => {
                console.log('error');
                console.log(err);
            });
    }
}
const mutations = {
    [types.CONTACTS_SUCCESS]: (state, response) => {
        state.contacts = response.data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}